import { Event } from '@/event-bus/event';

export class MassEditShowWarningMultipleOrganisationsEvent extends Event<void> {}
